import { Cache } from './shared/Cache';
import { Database as DB } from "./shared/Database";







type Content = {
	log: string,
	content: string,
}


function formatMessage(author: string, avatar: string, message: Content ) {
	return {
		author,
		avatar,
		...message,
		time: new Date().toLocaleTimeString(),
	}
}

async function cachedRequest(name: string, makeRequest: CallableFunction) {
	let content: string;
	let cachedMessage: string;

	const cache = Cache.get(name);
	if (cache) {
		cachedMessage = `[${name}] Cache: HIT`
		content = cache
	} else {
		content = await makeRequest();
		cachedMessage = `[${name}] Cache: MISS`;
		Cache.set(name, content);
	}

	return {
		log: cachedMessage,
		content,
	};
}

function getDadJoke() {
	const name = 'Dad Joke Bot';
	const avatar = 'dad-bot';
	return {
		name,
		avatar,
		getMessage: async () => {
			const joke = await cachedRequest(name, async () => {
				const response = await fetch('https://icanhazdadjoke.com/', {
					headers: {
						Accept: 'application/json'
					}
				});
				const data = await response.json();
				return data.joke;
			});
			return formatMessage(name, avatar, joke);
		}
	}
}

function getStoicismQuote() {
	const name = 'Stoicism Bot';
	const avatar = 'stoicism';
	return {
		name,
		avatar,
		getMessage: async () => {
			const quote = await cachedRequest(name, async () => {
				const response = await fetch('https://api.stoicism.io/quotes/random', {
					headers: {
						Accept: 'application/json'
					}
				})
				const json = await response.json();
				return json.data;
			});
			return formatMessage(name, avatar, quote);
		}
	}
}


function getComedianJoke() {
	const name = 'Comedian Bot';
	const avatar = 'comedian-bot';
	return {
		name,
		avatar,
		getMessage: async () => {
			return formatMessage(name, avatar, {
				content: await DB.getRandomJoke(),
				log: '[Comedian Bot] Cache: NONE',
			});
		}

	}
}

export default {
	getDadJoke: {
		class: getDadJoke,
		init: getDadJoke,
	},
	getStoicismQuote: {
		class: getStoicismQuote,
		init: getStoicismQuote,
	},
	getComedianJoke: {
		class: getComedianJoke,
		init: getComedianJoke
	},

}